// AI-CONTEXT: See docs/features/msi-effect-monetisation.md
//
// The meetstandaard-API id of the "Participatieladder" MSI effect. That effect
// carries monetaryValues in the API, but its euros are HARD-EXCLUDED from the
// MSI monetisation stream: the kenmerken-based Participatieladder monetisation
// (src/helpers/participationHelpers/) is richer and stays the only source for
// that value. Counting both would double-count the same outcome.
const PARTICIPATIELADDER_MSI_ID = 'ffba7445-7d2c-4a92-835c-9273c9a3478c'

export default PARTICIPATIELADDER_MSI_ID
